import React, { useEffect } from 'react';
import NavLando from '../components/public/NavLando';
import IntroHero from '../components/public/IntroHero';
import Manifesto from '../components/public/Manifesto';
import Showcase from '../components/public/Showcase';
import BeforeAfterShowcase from '../components/public/BeforeAfterShowcase';
import Features from '../components/public/Features';
import HowItWorks from '../components/public/HowItWorks';
import ComparisonTable from '../components/public/ComparisonTable';
import ComplianceShield from '../components/public/ComplianceShield';
import LikenessVault from '../components/public/LikenessVault';
import ImpactESG from '../components/public/ImpactESG';
import MetricsStrip from '../components/public/MetricsStrip';
import LooksHallOfFame from '../components/public/LooksHallOfFame';
import Reel from '../components/public/Reel';
import CapabilitiesStrip from '../components/public/CapabilitiesStrip';
import Pricing from '../components/public/Pricing';
import Testimonials from '../components/public/Testimonials';
import Logos from '../components/public/Logos';
import Team from '../components/public/Team';
import FAQ from '../components/public/FAQ';
import Contact from '../components/public/Contact';
import BoldFooter from '../components/public/BoldFooter';
import CustomCursor from '../components/public/CustomCursor';
import RegulatorBanner from '../components/public/RegulatorBanner';
import { useContent } from '../lib/content';
import { pickLocale } from '../lib/api';

export default function LandingPage() {
  const { content, locale } = useContent();

  useEffect(() => {
    const seo = content.seo || {};
    if (seo.title) document.title = pickLocale(seo.title, locale);
    const desc = pickLocale(seo.description, locale, '');
    if (desc) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) {
        m = document.createElement('meta');
        m.setAttribute('name', 'description');
        document.head.appendChild(m);
      }
      m.setAttribute('content', desc);
    }
  }, [content, locale]);

  return (
    <div className="relative grain min-h-screen bg-bg text-ink modaria-cursor-host">
      <CustomCursor />
      <RegulatorBanner />
      <NavLando />
      <main>
        <IntroHero />
        <Manifesto />
        <Showcase />
        <BeforeAfterShowcase />
        <Features />
        <HowItWorks />
        <Reel />
        <ComparisonTable />
        <ComplianceShield />
        <LikenessVault />
        <ImpactESG />
        <MetricsStrip />
        <LooksHallOfFame />
        <CapabilitiesStrip />
        <Pricing />
        <Testimonials />
        <Logos />
        <Team />
        <FAQ />
        <Contact />
      </main>
      <BoldFooter />
    </div>
  );
}
